import { gql } from "apollo-angular";

export const  QF = gql`
  fragment QF on Quotes {
    backgroundColor{
      color
    }
    title
    header
    headerTag
    hTagId
    content
    testimonialItemsCollection {
      items {
        ... on TestimonialItem {
          quote
          author
          authorCredentials
          media {
            description
            url
          }
          youTubeVideoLink
        }
      }
    }
    disclaimer {
      disclaimer
    }
}`;
